import {
  FaLaptopCode,
  FaMobileAlt,
  FaLayerGroup,
  FaGlobe,
} from "react-icons/fa";
import "./SeoAuthority.css";

const SeoAuthority = () => {
  return (
    <section
      className="oglitz-seo-authority"
      aria-labelledby="oglitz-seo-authority-title"
    >
      <div className="oglitz-seo-authority__container">
        {/* LEFT CONTENT */}
        <div className="oglitz-seo-authority__content">
          <span className="oglitz-seo-authority__eyebrow">
            Software Development Experts
          </span>

          <h2 id="oglitz-seo-authority-title">
            Website & Software Development Company
            <span> Building Scalable Digital Products</span>
          </h2>

          <p className="oglitz-seo-authority__lead">
            <strong>Oglitz Software</strong> is a trusted
            <strong> website design and software development company {" "}</strong>
            delivering high-performance digital solutions for modern businesses.
          </p>

          <p className="oglitz-seo-authority__sub">
            We build <strong>web applications</strong>,{" "}
            <strong>mobile apps</strong>,<strong> SaaS platforms</strong>, and{" "}
            <strong>enterprise software{" "}</strong>
            for startups and enterprises across
            <strong> India, Dubai</strong> and global markets.
          </p>
        </div>

        {/* RIGHT PANEL */}
        <div className="oglitz-seo-authority__features">
          <div className="feature">
            <FaLaptopCode />
            <span>Web Applications</span>
          </div>

          <div className="feature">
            <FaMobileAlt />
            <span>Mobile App Development</span>
          </div>

          <div className="feature">
            <FaLayerGroup />
            <span>SaaS & Enterprise Platforms</span>
          </div>

          <div className="feature">
            <FaGlobe />
            <span>Global Delivery Model</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SeoAuthority;
